export const ProductListDemo = {
    applicationList: [
        {
            id: 10,
            applicationTitle: '---------',
            description: 'Cloud-based radiology solution for efficient data management.',
            logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/radportal-3.svg',
            website: 'https://miracleadvance.com/radportal/',
            status: 'active',
            timeCreated: 1701320328,
            demo: true
        },
        {
            id: 11,
            applicationTitle: '---------',
            description: 'Cloud-based radiology solution for efficient data management.',
            logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/radportal-3.svg',
            website: 'https://miracleadvance.com/radportal/',
            status: 'active',
            timeCreated: 1701320328,
            demo: true
        }
    ]
};

export default null;
